/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/info': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<g class="nc-icon-wrapper" _fill="#272c33"><path pid="0" d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"/><path pid="1" data-color="color-2" d="M7 7h2v5H7z"/><circle pid="2" data-color="color-2" cx="8" cy="5" r="1"/></g>'
  }
})
